
import {  get } from '../helpers/api.helper';

export async function ListProducts(pageSize=0, page=0, paginated = false) {
    try {
        if(paginated)
            return await get(`produto/paginated?pageSize=${pageSize}&page=${page}`);
        else
            return await get('produto');
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function GetProduct(productsId) {
    try {
        return await get(`produto/${productsId}`);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function GetProductLikeName(name) {
    try {
        return await get(`produto/filter?name=${name}`);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function GetCplusIdProduct(productsId) {
    try {
        return await get(`produto/cplus/${productsId}`);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}



export async function GetSellerById(id) {
    try {
        return await get(`FinalizaVenda/${id}`);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function CreateSale(productsId) {
    try {

    } catch (error) {

    }
}